
import React from "react";
import "../src/style/RefundPolicy.css";

const RefundPolicy = () => {
    return (
        <>
            <nav
                className="breadcrumb"
                style={{
                    backgroundImage: "url('./airplane.avif')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    padding: "60px 20px",
                    color: "white",
                    textAlign: "left"
                }}
            >
                <a href="/" style={{ color: "white", fontWeight: "bold" }}>Home</a> &gt; <span>Refund Policy</span>
            </nav>

            <div className="refund-container container" style={{ padding: "40px 20px" }}>
                <h1 className="refund-title" style={{ textAlign: "left", fontWeight: "bold", marginBottom: "20px" }}>Refund Policy</h1>
                <p className="refund-text" style={{ textAlign: "justify", lineHeight: "1.8" }}>
                    We value our customers and aim to provide a seamless refund process. Please read our policy carefully to understand the terms and conditions.
                </p>

                <h2 className="refund-heading" style={{ textAlign: "left", fontWeight: "bold", marginTop: "30px" }}>1. Eligibility for Refunds</h2>
                <p className="refund-text" style={{ textAlign: "justify" }}>Refunds are applicable only for cancellations made within the stipulated time frame mentioned during booking.</p>

                <h2 className="refund-heading" style={{ textAlign: "left", fontWeight: "bold", marginTop: "30px" }}>2. Non-Refundable Bookings</h2>
                <p className="refund-text" style={{ textAlign: "justify" }}>Certain bookings, such as promotional offers and last-minute deals, may not be eligible for refunds.</p>

                <h2 className="refund-heading" style={{ textAlign: "left", fontWeight: "bold", marginTop: "30px" }}>3. Refund Processing Time</h2>
                <p className="refund-text" style={{ textAlign: "justify" }}>Refunds will be processed within 7-14 business days and will be credited to the original payment method.</p>

                <h2 className="refund-heading" style={{ textAlign: "left", fontWeight: "bold", marginTop: "30px" }}>4. Partial Refunds</h2>
                <p className="refund-text" style={{ textAlign: "justify" }}>In some cases, partial refunds may be provided based on airline policies and applicable cancellation fees.</p>

                <h2 className="refund-heading" style={{ textAlign: "left", fontWeight: "bold", marginTop: "30px" }}>5. How to Request a Refund</h2>
                <p className="refund-text" style={{ textAlign: "justify" }}>To request a refund, please contact our support team at <a href="mailto:support@example.com">support@example.com</a> with your booking details.</p>

                <h2 className="refund-heading" style={{ textAlign: "left", fontWeight: "bold", marginTop: "30px" }}>6. Changes to This Policy</h2>
                <p className="refund-text" style={{ textAlign: "justify" }}>We may update this policy from time to time. Any changes will be posted on this page.</p>

                <h2 className="refund-heading" style={{ textAlign: "left", fontWeight: "bold", marginTop: "30px" }}>7. Contact Us</h2>
                <p className="refund-text" style={{ textAlign: "justify" }}>If you have any questions about this Refund Policy, please contact us at <a href="mailto:support@example.com">support@example.com</a>.</p>
            </div>
        </>
    );
};

export default RefundPolicy;
